<template>
    <div class="partners__carousel">
        <div class="swiper-container partners-carousel" v-if="partners.length > 0">
            <div class="swiper-wrapper">
                <!-- Slides -->
                <div class="swiper-slide" v-for="(partner, index) in partners" :key="index">
                    <div class="partner">
                        <img :src="partner.img" alt="" class="partner__img">
                    </div>
                </div>
            </div>

            <!-- If we need navigation buttons -->
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            
        }
    },
    props: ['partners']
}
</script>

<style scoped>

</style>